function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { useDebounce } from '../../../hooks/use-debounce';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpTextAreaStyle } from './style';
/**
 * Text Area component properties.
 */

var OwnUpTextAreaImpl = createOwnUpComponent('textarea', OwnUpTextAreaStyle);
/**
 * Text Area component that supports debouncing and does not change the field
 *   while the user is in it.
 *
 * @param props - Seet {@link OwnUpTextAreaProperties}
 */

export var OwnUpTextArea = function OwnUpTextArea(_ref) {
  var className = _ref.className,
      name = _ref.name,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      debounce = _ref.debounce,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["className", "name", "placeholder", "value", "debounce", "onFocus", "onBlur", "onChange"]);

  // Build debounce state hooks based on input props.
  var debounceState = useDebounce({
    value: value,
    debounce: debounce,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  }); // Class name

  var builtClass = useMemo(function () {
    return buildClassNames('ou-text-area', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(OwnUpTextAreaImpl, _extends({
    className: builtClass,
    name: name,
    placeholder: placeholder
  }, debounceState, props));
};